import React, { Component } from 'react'

import { CrfContext } from "../../CrfContext";

import SideNav from "../sidenav/Sidenav";
import { Link } from 'react-router-dom';

import "./ApproveDepartment.css"

import axios from 'axios'

export class ApproveDepartment extends Component {
    state ={
        approvedRequest: false,
        requestingToJoin: [],
        userIdToApprove: "",
        userDepartments: [],
        userId: ""
    }

    componentDidMount(){
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              
    //   THIS WILL FILTER IF THE USER DEPARTMENT IS APPPROVED AND DEPARTMENT MATCH TO DEPARTMENT HEAD
            //   this.setState({
            //     requestingToJoin: response.data.data.filter(user => user.department.isApproved === false
            //         && user.department.centerName === headDepartment)
            //   })
            //   console.log(this.state.requestingToJoin)
    // ==================================================================================================
      this.setState({
                requestingToJoin: response.data.data
              })
              console.log(this.state.requestingToJoin)
          })
          .catch(error => {
              console.log(error.response)   
            })

        axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response.data.data)
          this.setState({
              userDepartments: response.data.data.departments[0].centerName,
              userId: response.data.data._id
          })
          let headDepartment = response.data.data.department.centerName
          let departmentHead = response.data.data
 
      })
      .catch(error => {
          console.log(error.response)   
        })

        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
    //   THIS WILL FILTER IF THE USER DEPARTMENT IS APPPROVED AND DEPARTMENT MATCH TO DEPARTMENT HEAD
            //   this.setState({
            //     requestingToJoin: response.data.data.filter(user => user.department.isApproved === false
            //         && user.department.centerName === headDepartment)
            //   })
            //   console.log(this.state.requestingToJoin)
    // ==================================================================================================
    //   this.setState({
    //             requestingToJoin: response.data.data
    //                 .filter(user => 
    //                 // user.department.isApproved === false && 
    //                 user.department.centerName === headDepartment  
    //                 &&
    //                 user._id !== departmentHead._id
    //                 )
    //           })
    //           console.log(this.state.requestingToJoin)
          })
          .catch(error => {
              console.log(error.response)   
            })
    }

    handleDepartmentStatus = (e) => {
        console.log(e.target)
        axios({
            method: 'PUT',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/approvedDepartment/${e.target.id}`,
            data: {
                centerCode: e.target.name
            },
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              window.location.reload()

              // this.setState({
              //   requestingToJoin: response.data.data.filter(user => user.department.isApproved === false
              //       && user.department.centerName === headDepartment)
              // })
              // console.log(this.state.requestingToJoin)
 
          })
          .catch(error => {
              console.log(error.response)   
            })
    }

    handleSubmitRequestDept = (e) => {
      console.log(e.target)
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/userInfo/removedDepartment/${e.target.id}`,
        data: {
            department: e.target.name
        },
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          if(response.data.data.nModified !== 0){
            window.location.reload()
          }
      })
      .catch(error => {
          console.log(error.response)   
        })
    } 

    render() {
      console.log(this.state.requestingToJoin)
     
        return (
            <CrfContext.Consumer>
      {(context) => (
          <div id="mainPage">
          <div id="sidePanel">
            <SideNav 
              testState = {context.state.testState}
              toggleBtn1List = {context.toggleBtn1List}
              toggleBtn2List = {context.toggleBtn2List}
              btn1List = {context.state.btn1List}
              btn2List = {context.state.btn2List}
              userRole = {context.state.userRole}
            />
          </div>
          <div id="mainPanel">
            <div className="requestSelectionPanel">
                    <div className="toApproveHeader">
                        <div>
                            <h1>{this.state.userDepartments}</h1>
                        </div>
                      
                        {/* TABLE HEAD */}
                        <div className="myRequestTableHeader">
                            <div className="tHead2">
                                <h4>User Name</h4>
                            </div>
                            <div className="tHead2">
                                <h4></h4>
                            </div>
                            <div className="tHead2">
                                
                            </div>
                            <div className="tHead2">
                                <h4></h4>
                            </div>
                        </div>
                        {/*END TABLE HEAD */}
                    </div>
                </div>
                {/* TABLE DATA */}
            <div className="divisionToApprove">

            </div>
            {(this.state.requestingToJoin.filter(usr => usr._id !== this.state.userId)).map(user => 
                // <Link style={link} to={`/CheckRequest/${user._id}`}>
                <div className="tableData">
                    <div className="tDataUser">
                        <h4>{user.firstName + " " + user.lastName}</h4>
                    </div>
                    <div className="tDataUser">
                        <h4>{user.email}</h4>
                    </div>
                    <div className="tDataUser">
                        {/* <h4 className="">{user.expectedCompletionDate ?
                        (user.expectedCompletionDate).slice(4,21) : '--'}
                        </h4> */}
                    </div>
                    <div className="tDataUser2">
                        {!user.isApproved ? 
                            <button id={user._id} type="button" className="approveDepartmentBtn"
                                name={user.centerCode}
                                onClickCapture={this.handleDepartmentStatus}
                            >
                                APPROVE AS A MEMBER
                            </button> 
                        : 
                        <>
                        <span className="approvedData">MEMBER</span>
                        <button id={user._id} name={this.state.userDepartments}
                                 className="removeFromDeptBtn"
                                 onClick={this.handleSubmitRequestDept}>
                                   &times;
                        </button>
                        </>
                        }
                    </div>
                </div>
            // </Link>
            )}
            
            </div>
        </div>

      )}
    </CrfContext.Consumer>
        )
    }
}

const link ={
    textDecoration: "none",
    color: "black"
}

export default ApproveDepartment
